import root from 'window-or-global';
import createHistory from 'history/createBrowserHistory';
import createMemoryHistory from 'history/createMemoryHistory';

export default root.isWaggle ? createMemoryHistory() : createHistory();



// WEBPACK FOOTER //
// ./src/common/config/history.js